"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageLDAPAuthenticatorSettings = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsLdapAuthenticatorSettings = require("../../components/DmsAuthenticatorsSettings/DmsLdapAuthenticatorSettings");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageLDAPAuthenticatorSettings Component
 * 
 * @description Component for managing LDAP authenticator settings within the system. 
 * Renders a DmsPage layout with a DmsAltBox containing the DmsLdapAuthenticatorSettings component.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageLDAPAuthenticatorSettings />
 * )
 * 
 * @returns {JSX.Element} The LDAP Authenticator Settings page.
 */
const DmsPageLDAPAuthenticatorSettings = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "LDAP Authenticator Settings"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("LDAPAuthenticatorSettings").d("LDAP Authenticator Settings"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsLdapAuthenticatorSettings.DmsLdapAuthenticatorSettings, null))));
};
exports.DmsPageLDAPAuthenticatorSettings = DmsPageLDAPAuthenticatorSettings;